module.exports = __webpack_public_path__ + "img/ETHicon.26d4af6c.svg";